export const TileViewerConstants = {
    UPDATE_TILE_VIEWER_APP_POSITION: "UPDATE_TILE_VIEWER_APP_POSITION", 
    UPDATE_TILE_VIEWER_APP_CLICK_TIME: "UPDATE_TILE_VIEWER_APP_CLICK_TIME"
} 